// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"9961f03d","336":"3741906e","466":"d03afeee","495":"cac604fb","497":"c365a819","564":"50a1b0be","654":"000c1e6d","685":"641a37df","751":"14e85f37","916":"a000851e","943":"45546652","953":"b5ba38fc","975":"609b45d3"}[chunkId] + ".chunk.js";
};